import { getStepsToBeShown } from '../../../utils/validation'
import { InteractionModelItemGroup } from 'types/shared'
import { useAppSelector } from 'state/store'

const useInteraction = () => {
  const {
    interactionModel: {
      data: interactionModelData,
      user,
      dateStartInteraction,
      geolocation
    }
  } = useAppSelector(({ interactions }) => interactions)

  return {
    interactionModelItemGroups: getStepsToBeShown(
      interactionModelData?.interaction_model_item_groups || []
    ) as InteractionModelItemGroup[],
    user,
    dateStartInteraction,
    geolocation
  }
}

export default useInteraction
